import { Controller } from "@hotwired/stimulus"

/**
 * Opens an associated <dialog> via showModal().
 *
 * The controller is attached to the trigger button. The dialog is
 * located by ID via the `data-alt-install-modal-target-id-value`
 * attribute. Closing uses the dialog's own <form method="dialog">.
 */
export default class extends Controller {
  static values = { targetId: String }

  declare targetIdValue: string

  open(event?: Event) {
    event?.preventDefault()
    const dialog = document.getElementById(this.targetIdValue) as HTMLDialogElement | null
    dialog?.showModal()
  }
}
